export const ACTIVE_BRAND_KIT_STORAGE_KEY = 'mora.create.activeBrandKitId';

export function readStoredActiveBrandKitId(): string | null {
  try {
    const stored = window.localStorage.getItem(ACTIVE_BRAND_KIT_STORAGE_KEY);
    return stored ? stored : null;
  } catch {
    return null;
  }
}

export function writeStoredActiveBrandKitId(kitId: string): void {
  try {
    window.localStorage.setItem(ACTIVE_BRAND_KIT_STORAGE_KEY, kitId);
  } catch {
    return;
  }
}

export function clearStoredActiveBrandKitId(): void {
  try {
    window.localStorage.removeItem(ACTIVE_BRAND_KIT_STORAGE_KEY);
  } catch {
    return;
  }
}
